// extracted by mini-css-extract-plugin
module.exports = {"guess-results":"GuessList_guess-results__mQQvm","guess-container":"GuessList_guess-container__v3Kuk"};